<div class="basicrow txt-center p-30">
  <div class="overallpadded-c">
    <div class="basicrow addservices-title roboto-l m-top15">
      &#191;Quieres agregar un Servicio Adicional a tu dispositivo {{this.nameDevice}}&#63;
    </div>
    <div class="basicrow txt-center">
      <div class="overallpadded-c carousel-sva">
        <mat-carousel class="plan-guide-sva" timings="2000ms ease-in" [autoplay]="false" color="accent"
          [interval]="this.rotationTime" maxWidth="auto" [loop]="true" [hideArrows]="this.hideArrows"
          [hideIndicators]="this.hideArrows" [useKeyboard]="true" [useMouseWheel]="false">
          <mat-carousel-slide *ngFor="let item of this.svaCarrousel; let i = index" [hideOverlay]="true">
            <div class="plans-box-container m-top-p">
              <div class="addservicechoices" *ngFor="let plan of item; let j = index"
                [ngClass]="{'addservicechoicesOff': plan.bitEnable==false,'selectedON':plan.selected==true}">
                <div *ngFor="let list of this.promoList; let z = index">
                  <div class="container-headband" *ngIf=" plan.planId==list.idPlan && list.data.offers.length!=0 ">
                    <div class="container-headband-1">
                      <img width="100%" height="100%" class="renew-icon" src="/assets/images/offers/tag_oferta.png">
                    </div>
                  </div>
                  <div class="ofert-title roboto-m" *ngIf=" plan.planId==list.idPlan && list.data.offers.length!=0 ">
                    <div>
                      <img width="20px" height="20px" class="renew-icon" src="/assets/images/offers/tag_white.png">
                    </div>
                    <div class="txt-left">
                      <a matTooltip="{{this.promoList[z].data.offers[0].planName}}" class="servicetermslink2 cursor"
                        (click)="this.popTermOffers(this.promoList[z].data.offers[0].planDesc)">
                        {{(this.global.textShortener((this.promoList[z].data.offers[0].planName),'',16,'...'))}}
                      </a>
                    </div>
                  </div>
                  <div class="no-ofert-title roboto-m" *ngIf="plan.planId==list.idPlan && list.data.offers.length==0">
                  </div>
                </div>
                <div class="overallpadded-c-i">
                  <div class="basicrow grid-img-sva">
                    <img width="100%" class="addservice-icon" *ngIf="item.imgUrl!=''" src="{{plan.imgUrl}}">
                    <img width="100%" class="addservice-icon" *ngIf="item.imgUrl==''"
                      src="../../assets/images/addservice-icon04.png">
                  </div>
                  <div class="inneraddservice-title roboto-b vcenter">
                    <div class="tabcell">
                      {{plan.planName}}
                    </div>
                  </div>
                  <div class="addservice-numb">
                    {{plan.decPrice|currency}}
                  </div>
                  <div class="sva-description">
                    <div [innerHTML]="this.global.textShortener((plan.planDesc),'',120,'...')"></div>
                    <div>
                      {{plan.productName}}
                      <div style="padding: 5px 0px;" *ngIf="plan.hasChannels==true">
                        <a (click)="this.openPupUp(this.currentParentProductId,plan.planName,plan.planId)" class="linkdefs"> 
                          Ver Guía de Canales&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="plan.bitEnable==true || plan.bitEnable==undefined ">
                    <div class="innerservice-btn vcenter" (click)="this.selectSva(plan);"
                      [ngClass]="{'innerservice-btnOn': plan.selected==true,'innerservice-btnOn2':plan.bitInclude==true}">
                      <div class="tabcell" *ngIf="plan.bitInclude==true">
                        Incluido
                      </div>
                      <div class="tabcell" *ngIf="plan.bitInclude==false">
                        Elegir servicio
                      </div>
                    </div>
                  </div>
                  <div *ngIf="plan.bitEnable==false">
                    <div class="innerservice-btn vcenter no-selected">
                      <div class="tabcell">
                        No Disponible
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-carousel-slide>
        </mat-carousel>
      </div>
    </div>
    <div class="innerservices-grayline"></div>
    <div *ngIf="this.svaSelected.length>0">
      <div class="basicrow txt-left">
        <input type="checkbox" class="cursor" [(ngModel)]="this.checkterms">
        <a class="servicetermslink cursor" (click)="this.pupOpTermns()">
          Acepto t&eacute;rminos y condiciones de Servicios Adicionales ClaroTv+
        </a>
      </div>
    </div>
    <div class="basicrow">
      <div class="addservicescontinuebtn vcenter" (click)="this.continue()"
        [ngClass]="{'innerservice-btnOn': this.svaSelected.length>0}">
        <span class="tabcell" *ngIf="this.svaSelected.length==0">
          NO, GRACIAS. DESEO CONTINUAR
        </span>
        <span class="tabcell" *ngIf="this.svaSelected.length>0">
          CONTINUAR
        </span>
      </div>
    </div>
  </div>
</div>
